import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  deviceTabs: {
    background: 'transparent',
    color: theme.scenes.textColor,
  },
}))

export default useStyles
